<div #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='memberExportModalEmailDialogClose' type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="myModalLabel">Enter recipient email address</h4>
      </div>
      <form (ngSubmit)="submitRecipientEmail(form)" #form="ngForm">
        <div class="modal-body">
          <div class="member-modal-cont">
            <div class="form-group">
              <label for="member-email">Email</label>
              <input
                type="text"
                class="form-control"
                name="email"
                ngModel
                class="form-control"
                id="member-email"
                required
                email
                [readonly]="loading"
                #email="ngModel"
              />
              <small class="text-danger" *ngIf="(email.touched || email.dirty) && !email.valid"> Email is invalid. </small>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button id='memberExportModalEmailDialogSend' [disabled]="!form.valid" type="submit" class="btn btn-success default-btn">Send Email</button>
        </div>
      </form>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/member-export-modal-email-dialog/member-export-modal-email-dialog.component.html